/*
 * Based on https://github.com/joaopfg/vat-number-validator but was unhappy with the repo
 * */

export const supportedVatCountries: {
  [iso: string]: { name: string; regex?: string };
} = {
  AL: { name: 'Albania', regex: String.raw`^[J-KL-M]\d{8}[A-Z]$` },
  AR: { name: 'Argentina', regex: String.raw`^\d{11}$` },
  AU: { name: 'Australia', regex: String.raw`^\d{11}$` },
  AT: { name: 'Austria', regex: String.raw`^ATU\d{8}$` },
  BY: { name: 'Belarus', regex: String.raw`^\d{9}$` },
  BE: {
    name: 'Belgium',
    regex: String.raw`^(BE0?|BE1)\d{8}(?:(?<=\d)(\d{2})|(?<=\d)(\d{1})X)$`,
  },
  BZ: { name: 'Belize', regex: String.raw`^\d{6}$` },
  BO: { name: 'Bolivia', regex: String.raw`^\d{7}$` },
  BA: { name: 'Bosnia Herzegovina', regex: String.raw`^\d{12,13}$` },
  BR: { name: 'Brazil', regex: String.raw`^\d{11}|\d{14}$` },
  BG: { name: 'Bulgaria', regex: String.raw`^BG\d{9,10}$` },
  CA: { name: 'Canada', regex: String.raw`^\d{9}$` },
  CL: { name: 'Chile', regex: String.raw`^\d{8}-[0-9K]$` },
  CN: { name: 'China', regex: String.raw`^[a-zA-Z0-9]{18}$` },
  CO: { name: 'Colombia', regex: String.raw`^\d{9}-[0-9]$` },
  CR: { name: 'Costa Rica', regex: String.raw`^(\d{9,12})$` },
  HR: { name: 'Croatia', regex: String.raw`^HR\d{11}$` },
  CY: { name: 'Cyprus', regex: String.raw`^CY\d{8}[A-Z]$` },
  CZ: { name: 'Czech Republic', regex: String.raw`^CZ\d{8,10}$` },
  DK: { name: 'Denmark', regex: String.raw`^DK\d{8}$` },
  DO: { name: 'Dominican Republic', regex: String.raw`^[145][0-9]{8}$` },
  EC: { name: 'Ecuador', regex: String.raw`^\d{13}$` },
  SV: { name: 'El Salvador', regex: String.raw`^\d{4}-\d{6}-\d{3}-\d$` },
  EE: { name: 'Estonia', regex: String.raw`^EE\d{9}$` },
  FI: { name: 'Finland', regex: String.raw`^FI\d{7,8}$` },
  FR: { name: 'France', regex: String.raw`^FR\d{11}$` },
  DE: { name: 'Germany', regex: String.raw`^DE\d{9}$` },
  GR: { name: 'Greece', regex: String.raw`^EL\d{9}$` },
  GT: { name: 'Guatemala', regex: String.raw`^\d{7}-\d$` },
  HU: { name: 'Hungary', regex: String.raw`^HU\d{8}$` },
  IS: { name: 'Iceland', regex: String.raw`^\d{5,6}$` },
  IN: { name: 'India', regex: String.raw`^[a-zA-Z0-9]{15}$` },
  ID: { name: 'Indonesia', regex: String.raw`^\d{15,16}$` },
  IE: { name: 'Ireland', regex: String.raw`^IE(\d{7}[A-Z]|(\d{7}[A-Z]{2}))$` },
  IM: {
    name: 'Isle of Man',
    regex: String.raw`^GB(\d{3} \d{4} \d{2}|\d{9}|\d{9} \d{3}|GD([0-4][0-9]{2})|HA([5-9][0-9]{2}))$`,
  },
  IL: { name: 'Israel', regex: String.raw`^\d{9}$` },
  IT: { name: 'Italy', regex: String.raw`^IT\d{11}$` },
  JP: { name: 'Japan', regex: String.raw`^\d{13}$` },
  KZ: { name: 'Kazakhstan', regex: String.raw`^\d{12}$` },
  LV: { name: 'Latvia', regex: String.raw`^LV\d{11}$` },
  LT: { name: 'Lithuania', regex: String.raw`^LT\d{9}(\d{3})?$` },
  LU: { name: 'Luxembourg', regex: String.raw`^LU\d{8}$` },
  MT: { name: 'Malta', regex: String.raw`^MT\d{8}$` },
  MX: { name: 'Mexico', regex: String.raw`^[A-Z&Ñ]{3,4}\d{6}[0-9A-Z]{3}$` },
  MC: { name: 'Monaco', regex: String.raw`^FR\d{11}$` },
  NL: { name: 'Netherlands', regex: String.raw`^NL\d{9}B\d{2}$` },
  NZ: { name: 'New Zealand', regex: String.raw`^\d{8,9}$` },
  NI: { name: 'Nicaragua', regex: String.raw`^\d{3}-\d{6}-\d{4}[A-Za-z]$` },
  NG: { name: 'Nigeria', regex: String.raw`^\d{8}-\d{4}$` },
  MK: { name: 'North Macedonia', regex: String.raw`^MK\d{13}$` },
  NO: { name: 'Norway', regex: String.raw`^\d{9}$` },
  PY: { name: 'Paraguay', regex: String.raw`^\d{6,8}-\d$` },
  PE: { name: 'Peru', regex: String.raw`^\d{11}$` },
  PH: { name: 'Philippines', regex: String.raw`^\d{12}$` },
  PL: {
    name: 'Poland',
    regex: String.raw`^PL(?:\d{3}-\d{3}-\d{2}-\d{2}|\d{3}-\d{2}-\d{2}-\d{3}|\d{10})$`,
  },
  PT: { name: 'Portugal', regex: String.raw`^PT\d{9}$` },
  RO: { name: 'Romania', regex: String.raw`^RO\d{2,10}$` },
  RU: { name: 'Russia', regex: String.raw`^\d{10}(?:\d{2})?$` },
  SM: { name: 'San Marino', regex: String.raw`^\d{5}$` },
  SA: { name: 'Saudi Arabia', regex: String.raw`^\d{15}$` },
  RS: { name: 'Serbia', regex: String.raw`^\d{9}$` },
  SK: { name: 'Slovakia', regex: String.raw`^SK\d{10}$` },
  SI: { name: 'Slovenia', regex: String.raw`^SI\d{8}$` },
  KR: { name: 'South Korea', regex: String.raw`^(\d{10}|\d{3}-\d{2}-\d{5})$` },
  ES: { name: 'Spain', regex: String.raw`^ES[A-Z]\d{7}[A-Z0-9]$` },
  SE: { name: 'Sweden', regex: String.raw`^SE\d{12}$` },
  CH: {
    name: 'Switzerland',
    regex: String.raw`^CHE-\d{3}\.\d{3}\.\d{3}\s(?:MWST|TVA|IVA)$`,
  },
  TW: { name: 'Taiwan', regex: String.raw`^\d{8}$` },
  TR: { name: 'Turkey', regex: String.raw`^\d{10}$` },
  UA: { name: 'Ukraine', regex: String.raw`^\d{12}$` },
  GB: {
    name: 'United Kingdom',
    regex: String.raw`^GB(\d{3} \d{4} \d{2}|\d{9}|\d{9} \d{3}|GD([0-4][0-9]{2})|HA([5-9][0-9]{2}))$`,
  },
  UY: { name: 'Uruguay', regex: String.raw`^\d{8}001\d$` },
  UZ: { name: 'Uzbekistan', regex: String.raw`^[24-7]\d{8}$` },
  US: {
    name: 'United States of America',
    regex: undefined,
  },
  VE: { name: 'Venezuela', regex: String.raw`^(J|G|V|E)-\d{9}$` },
};

export const vatFunctions: {
  [iso: string]: (vat: string) => boolean;
} = {
  AU: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.AU.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const number = vat.slice(2);
    const checkDigit = vat.slice(0, 2);
    const weights = [3, 5, 7, 9, 11, 13, 15, 17, 19];
    let sum = 0;

    for (let i = 0; i < weights.length; i += 1) {
      sum += -weights[i] * parseInt(number.charAt(i), 10);
    }

    const modResult = (sum - 1) % 89;
    const positiveModResult = modResult < 0 ? modResult + 89 : modResult;
    const expectedCheckDigit = String(11 + positiveModResult);

    return checkDigit === expectedCheckDigit;
  },
  BR: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.BR.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    if (vat.length === 14) {
      const weightsFirstDigit = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      const weightsSecondDigit = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;

      for (let i = 0; i < 12; i += 1) {
        sum += parseInt(vat.charAt(i), 10) * weightsFirstDigit[i];
      }

      let remainder = sum % 11;
      const firstCheckDigit = remainder <= 1 ? 0 : 11 - remainder;

      if (parseInt(vat.charAt(12), 10) !== firstCheckDigit) {
        return false;
      }

      sum = 0;

      for (let i = 0; i < 13; i += 1) {
        sum += parseInt(vat.charAt(i), 10) * weightsSecondDigit[i];
      }

      remainder = sum % 11;
      const secondCheckDigit = remainder <= 1 ? 0 : 11 - remainder;

      return parseInt(vat.charAt(13), 10) === secondCheckDigit;
    }

    if (vat.length === 11) {
      const weightsFirstDigit = [10, 9, 8, 7, 6, 5, 4, 3, 2];
      const weightsSecondDigit = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;

      for (let i = 0; i < 9; i += 1) {
        sum += parseInt(vat.charAt(i), 10) * weightsFirstDigit[i];
      }

      let remainder = sum % 11;
      const firstCheckDigit = remainder <= 1 ? 0 : 11 - remainder;

      if (parseInt(vat.charAt(9), 10) !== firstCheckDigit) {
        return false;
      }

      sum = 0;

      for (let i = 0; i < 10; i += 1) {
        sum += parseInt(vat.charAt(i), 10) * weightsSecondDigit[i];
      }

      remainder = sum % 11;
      const secondCheckDigit = remainder <= 1 ? 0 : 11 - remainder;

      return parseInt(vat.charAt(10), 10) === secondCheckDigit;
    }

    return false;
  },
  CH: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.CH.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.replace(/\D/g, '');
    const weights = [5, 4, 3, 2, 7, 6, 5, 4];
    let sum = 0;

    for (let i = 0; i < 8; i += 1) {
      sum += parseInt(digits[i], 10) * weights[i];
    }

    const remainder = sum % 11;
    const checksum = remainder <= 1 ? 0 : 11 - remainder;
    const vatChecksum = parseInt(vat.charAt(8), 10);

    return checksum === vatChecksum;
  },
  CL: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.CL.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const checkDigit = vat.charAt(9);
    const digits = vat.slice(0, 8);

    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < digits.length; i += 1) {
      sum += parseInt(digits.charAt(i), 10) * weights[i];
    }

    const remainder = sum % 11;
    const calculatedCheckDigit = 11 - remainder;

    if (calculatedCheckDigit === 11) {
      return checkDigit === '0';
    }
    if (calculatedCheckDigit === 10) {
      return checkDigit === 'K';
    }
    return parseInt(checkDigit, 10) === calculatedCheckDigit;
  },
  CO: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.CO.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const checkDigit = vat.charAt(10);
    const digits = vat.slice(0, 9);

    const weights = [41, 37, 29, 23, 19, 17, 13, 7, 3];
    let sum = 0;

    for (let i = 0; i < digits.length; i += 1) {
      sum += parseInt(digits.charAt(i), 10) * weights[i];
    }

    const remainder = sum % 11;
    const calculatedCheckDigit =
      remainder === 0 || remainder === 1 ? remainder : 11 - remainder;
    return parseInt(checkDigit, 10) === calculatedCheckDigit;
  },
  DO: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.DO.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const checkDigit = vat.charAt(8);
    const digits = vat.slice(0, 8);
    const weights = [7, 9, 8, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < digits.length; i += 1) {
      sum += parseInt(digits.charAt(i), 10) * weights[i];
    }

    const remainder = sum % 11;
    const result = 10 - remainder;
    const positiveModResult = ((result % 9) + 9) % 9;
    const calculatedCheckDigit = positiveModResult + 1;

    return parseInt(checkDigit, 10) === calculatedCheckDigit;
  },
  FR: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.FR.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const validationKey = Number(vat.substring(2, 4));
    const siren = vat.substring(4);
    const calculatedKey = (12 + 3 * (Number(siren) % 97)) % 97;

    return validationKey === calculatedKey;
  },
  IL: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.IL.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.split('').map(Number);
    let sum = 0;

    for (let i = 0; i < 9; i += 1) {
      let digit = digits[i];

      if (i % 2 === 1) {
        digit *= 2;

        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
    }

    return sum % 10 === 0;
  },
  IT: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.IT.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.substring(2).split('').map(Number);

    digits.reverse();

    let sum = 0;

    for (let i = 0; i < digits.length; i += 1) {
      let digit = digits[i];

      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
    }

    return sum % 10 === 0;
  },
  MC: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.FR.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const validationKey = Number(vat.substring(2, 4));
    const siren = vat.substring(4);
    const calculatedKey = (12 + 3 * (Number(siren) % 97)) % 97;

    return validationKey === calculatedKey;
  },
  NO: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.NO.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.split('').map(Number);
    let sum = 0;

    for (let i = 0; i < 8; i += 1) {
      sum += digits[i] * [3, 2, 7, 6, 5, 4, 3, 2][i];
    }

    const remainder = sum % 11;
    const checkDigit = remainder <= 1 ? 0 : 11 - remainder;

    return checkDigit === digits[8];
  },
  PE: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.PE.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const number = vat.slice(0, 10);
    const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    const weightedSum = weights.reduce((sum, weight, index) => {
      const digit = parseInt(number.charAt(index), 10);
      return sum + weight * digit;
    }, 0);
    const checkDigit = (11 - (weightedSum % 11)) % 10;
    const calculatedCheckDigit = String(checkDigit);
    const providedCheckDigit = vat.charAt(10);

    return calculatedCheckDigit === providedCheckDigit;
  },
  PH: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.PH.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const sequentialDigits = vat.substring(1, 8);

    for (let i = 1; i < 7; i += 1) {
      if (
        parseInt(sequentialDigits[i], 10) !==
        parseInt(sequentialDigits[i - 1], 10) + 1
      ) {
        return false;
      }
    }

    return true;
  },
  PY: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.PY.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digitsOnly = vat.replace(/\D/g, '');
    const checkDigit = digitsOnly.charAt(digitsOnly.length - 1);
    const digits = digitsOnly.slice(0, -1);
    let sum = 0;

    for (let i = 0; i < digits.length; i += 1) {
      sum += (i + 2) * parseInt(digits.charAt(digits.length - i - 1), 10);
    }

    const mod11 = ((-sum % 11) + 11) % 11;
    const mod10 = ((mod11 % 10) + 10) % 10;
    const calculatedCheckDigit = String(mod10);

    return checkDigit === calculatedCheckDigit;
  },
  RS: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.RS.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.split('').map(Number);
    let sum = 10;

    for (let i = 0; i < 8; i += 1) {
      sum += digits[i];
      sum %= 10;

      if (sum === 0) {
        sum = 10;
      }

      sum *= 2;
      sum %= 11;
    }

    const expectedChecksum = (11 - sum) % 10;

    return expectedChecksum === digits[8];
  },
  SK: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.SK.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const num = BigInt(vat.substring(2));

    return num % BigInt(11) === BigInt(0);
  },
  TW: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.TW.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const digits = vat.split('').map(Number);
    const weights = [1, 2, 1, 2, 1, 2, 4, 1];
    let sum = 0;

    for (let i = 0; i < 8; i += 1) {
      const product = digits[i] * weights[i];
      if (product >= 10) {
        sum += Math.floor(product / 10) + (product % 10);
      } else {
        sum += product;
      }
    }

    return sum % 10 === 0;
  },
  UY: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.UY.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const number = vat.slice(0, 11);
    const weights = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const total = weights.reduce((sum, weight, index) => {
      const digit = parseInt(number.charAt(index), 10);
      return sum + digit * weight;
    }, 0);
    const mod11 = ((-total % 11) + 11) % 11;
    const calculatedCheckDigit = mod11.toString();
    const providedCheckDigit = vat.charAt(11);

    return calculatedCheckDigit === providedCheckDigit;
  },
  VE: (vat: string) => {
    const vatRegex = new RegExp(supportedVatCountries.VE.regex ?? '');

    if (!vatRegex.test(vat)) {
      return false;
    }

    const number = vat.slice(0, 10).replace(/[-\s]/g, '');
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    const companyTypes: { [key: string]: number } = {
      V: 4, // natural person born in Venezuela
      E: 8, // foreign natural person
      J: 12, // company
      P: 16, // passport
      G: 20, // government
    };
    let sum = companyTypes[number[0]];
    for (let i = 0; i < 8; i += 1) {
      sum += weights[i] * parseInt(number.charAt(i + 1), 10);
    }

    const calculatedCheckDigit = '00987654321'[sum % 11];
    const providedCheckDigit = vat.charAt(10);

    return calculatedCheckDigit === providedCheckDigit;
  },
};
